import React, { useState, useEffect } from 'react';
import { firestore } from '../Firebase';

const DynamicBoxOutput = ({ content, videoData }) => {
  const hasDirectContent = content !== undefined && content !== null;
  const [displayContent, setDisplayContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchActiveSlide = async () => {
      if (!videoData?.id || !videoData?.activeSlideId) return;
  
      setIsLoading(true);
      try {
        const slideDoc = await firestore
          .collection('videos')
          .doc(videoData.id)
          .collection('dynamicbox')
          .doc(videoData.activeSlideId)
          .get();
  
        if (slideDoc.exists) {
          const slideContent = slideDoc.data().content || '';
          setDisplayContent(slideContent);
        } else {
          // Fallback to legacy format if slide doesn't exist
          setDisplayContent(videoData.dynamicBox || '');
        }
      } catch (error) {
        console.error('Error fetching slide:', error);
        // Fallback to legacy format on error
        setDisplayContent(videoData.dynamicBox || '');
      } finally {
        setIsLoading(false);
      }
    };

    // Direct content from editor is rendered directly from props below.
    if (hasDirectContent) return;

    // Otherwise, fetch from Firestore
    if (videoData?.id && videoData?.activeSlideId) {
      fetchActiveSlide();
    } else if (videoData?.dynamicBox) {
      // Fallback to direct dynamicBox (legacy format)
      setDisplayContent(videoData.dynamicBox);
    } else {
      setDisplayContent('');
    }
  }, [hasDirectContent, videoData]);

  // Process HTML content
  const createMarkup = (htmlContent) => {
    if (!htmlContent) return { __html: '' };

    // Replace React className with HTML class
    const processedContent = htmlContent.replace(/className=/g, 'class=');

    return { __html: processedContent };
  };

  const outputContent = hasDirectContent ? content : displayContent;

  if (!isLoading && !outputContent.trim()) return null;

  return (
    <div className="dynamic-box-output">
      {isLoading ? (
        <div className="output-display text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          className="output-display"
          dangerouslySetInnerHTML={createMarkup(outputContent)}
        />
      )}
    </div>
  );
};

export default DynamicBoxOutput;
